import { render, staticRenderFns } from "./TaxRegistrationForm.vue?vue&type=template&id=5bc26b92&scoped=true&"
import script from "./TaxRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./TaxRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./TaxRegistrationForm.vue?vue&type=style&index=0&id=5bc26b92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc26b92",
  null
  
)

export default component.exports